import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import CartProduct from './CartProduct';
import CartInvoice from './CartInvoice';
import * as actions from 'actions/index';

const Cart = props => {
  useEffect(() => {
    props.onFetchingCards();
  }, []);

  return (
    <div
      style={{ display: props.cart.checkout ? 'block' : 'none' }}
      className="cart-sidebar"
    >
      {props.cart.isInvoice ? <CartInvoice /> : <CartProduct />}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    cart: state.cartReducer.cart,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchingCards: () => dispatch(actions.fetchingCards()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Cart));



// WEBPACK FOOTER //
// ./src/containers/Menu/Cart/Cart.js